<template>
    <div>
        <div>
            <!-- 类型: -->
            <Select v-model="type" style="width:100px" @on-change='changeType'>
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <!-- 城市: -->
            <Select v-model="cityName" style="width:100px" @on-change='changeCity(cityName)'>
                <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <!-- 类别: -->
            <Select v-model="userType" style="width:100px" @on-change='changeUserType'>
                <Option v-for="item in userTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <!-- 人员: -->
            <Select v-model="userName" style="width:100px" @on-change='changeUser'>
                <Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <!-- 日期: -->
            <DatePicker type="daterange" @on-change="dateChange" placement="bottom-end" placeholder="选择日期" style="width: 100px"></DatePicker>
            <Button type="primary" v-on:click="search()">确定</Button>
            <Button type="primary" v-on:click="controlTable()">{{btableText}}</Button>
            <Button type="primary" v-on:click="downAllData()" v-if="dowloadAdata">下载数据</Button>

            <DatePicker type="month" @on-change="downDate" placement="bottom-end" v-if="dowloadAdata" placeholder="下载月份" style="width: 100px"></DatePicker>
            <Button type="primary" v-on:click="downNormal()" v-if="dowloadAdata">下载实际数据</Button>
            <Button type="primary" v-on:click="downPlan()" v-if="dowloadAdata">下载规划数据</Button>
        </div>
        <div class='map-control'>
          <div id="mapContainer">我是地图</div>
        </div>
        <div v-show='tableShow' class='list_control'>
          <div class='control'>
            <RadioGroup v-model="rg" type="button" @on-change='rgChange' class='pull-left'>
              <Radio label="规划线路"></Radio>
              <Radio label="实际路线"></Radio>
            </RadioGroup>
            <div class='btn-groups pull-right'>
              <Button v-on:click="dowload()">下载数据</Button>
              <Button v-on:click="hideTable()">隐藏</Button>
            </div>
          </div>
          <template>
            <Table size="small" :columns="columns1" :data="data1"></Table>
          </template>
          <Page class='page_control' :current='currentPage' :total="totalSize" :page-size='pageSize' size="small" @on-change='pageChange'></Page>
        </div>
    </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";
import excelUtil from "../service/excelUtil";
import stringUtil from "../service/stringUtil.js";
const appConfig = require("../../config/config.js");

import moment from "moment";
const getColors = [
  "5D4A43",
  "12BBD2",
  "1DF3BE",
  "18FFFF",
  "658EB7",
  "3236B7",
  "0467B7",
  "D59E87",
  "6FB1B6",
  "004325",
  "D0021B",
  "606E6C",
  "D500F9",
  "8832FF",
  "651FFE",
  "9010A4",
  "FF675C",
  "AE99DB",
  "5F4A9A",
  "5D6670",
  "9BB6B9",
  "6A9BC7",
  "DD55B3",
  "EEB3D4",
  "2F6D81",
  "886768",
  "5CBB16",
  "9E9E24",
  "548B2D",
  "B3FE59"
];

let osmurl =
  "https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}";
// "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";
export default {
  data: function() {
    return {
      btableText: "查看列表",
      currentPage: 1,
      totalSize: 0,
      pageSize: 5,
      type: "",
      typeList: [],
      rg: "规划线路",
      cityName: "",
      userType: "全部",
      userName: "",
      selectUserId: "",
      startDate: "",
      endDate: "",
      layerGroup: new L.layerGroup([]),
      cityUserMap: "",
      cityList: [],
      userTypeMap: new Map(),
      userTypeList: [
        {
          value: "全部",
          label: "全部"
        },
        {
          value: "BC",
          label: "BC"
        },
        {
          value: "ABC",
          label: "ABC"
        }
      ],
      userList: [],
      planMarkers: [],
      planLine: [],
      normalMarkers: [],
      normalLine: [],
      tableShow: false,
      columns1: [],
      //基本的信息
      basicInfo: [
        {
          title: "序号",
          key: "num"
        },
        {
          title: "日期",
          key: "date"
        },
        {
          title: "客户数",
          key: "custCount"
        },
        {
          title: "里程(km)",
          key: "distance"
        },
        {
          title: "工作时长",
          key: "time"
        },
        // {
        //   title: "效率值",
        //   key: "efficiency"
        // },
        {
          title: "老客户数",
          key: "oldCust"
        },
        {
          title: "新客户数",
          key: "newCust"
        }
      ],
      //实际线路需要显示的
      times: [
        {
          title: "起始时间",
          key: "startTime"
        },
        {
          title: "终止时间",
          key: "endTime"
        }
      ],
      data1: [], //每页展示的
      totalData: [], //全部的
      planListDates: [], //计划列表组织
      normalListDates: [], //实际线路列表组织
      checkType: 0, //默认列表显示
      checkCity: "", //选中的城市
      dowloadAdata: true, //是否支持下载全部数据
      downMonth: ""
    };
  },
  mounted() {
    //初始化地图
    this.map = L.map("mapContainer", {
      center: [31.120049, 121.30765],
      zoom: 10,
      minZoom: 1,
      maxZoom: 18,
      projection: L.Projection.LonLat,
      attributionControl: false,
      zoomControl: false
    });
    L.tileLayer(osmurl).addTo(this.map);
    L.control
      .zoom({
        position: "bottomright",
        zoomInTitle: "放大",
        zoomOutTitle: "缩小"
      })
      .addTo(this.map);
    L.control
      .scale({
        imperial: false
      })
      .addTo(this.map);
    this.layerGroup.addTo(this.map);
    this.getCustCity();
    this.configDowload();
  },
  methods: {
    search() {
      //确定进行查询
      if (this.selectUserId !== "all") {
        this.removeNormal();
        this.removePlan();
        this.planMarkers = [];
        this.planLine = [];
        this.normalMarkers = [];
        this.normalLine = [];
        this.planListDates = []; //数据列表
        this.normalListDates = []; //数据列表
        this.totalSize = 0;
        this.data1 = [];
        this.rg = "规划线路";
        if (!this.startDate || !this.endDate) {
          this.$Message.info("请选择日期");
          return;
        }
        if (this.type === "0") {
          this.getPlanDatas(this.selectUserId, this.startDate, this.endDate);
        } else if (this.type === "1") {
          this.getNormalDatas(this.selectUserId, this.startDate, this.endDate);
        } else if (this.type === "2") {
          this.getPlanDatas(this.selectUserId, this.startDate, this.endDate);
          this.getNormalDatas(this.selectUserId, this.startDate, this.endDate);
        }
      } else {
        this.$Message.info("全部用户暂时只支持下载");
      }
    },
    dowload() {
      let title = [];
      for (let col of this.columns1) {
        title.push(col.title);
      }
      let contents = [];
      if (this.checkType === 0) {
        //列表展示
        for (let i = 0; i < this.planListDates.length; i++) {
          const obj = this.planListDates[i];
          const content = [];
          for (let str in obj) {
            content.push(obj[str]);
          }
          contents.push(content);
        }
      } else {
        //实际展示
        for (let i = 0; i < this.normalListDates.length; i++) {
          const obj = this.normalListDates[i];
          const content = [];
          for (let str in obj) {
            content.push(obj[str]);
          }
          contents.push(content);
        }
      }
      contents.splice(0, 0, title); //插入标题列
      excelUtil.download(contents, "lines.xlsx");
    },
    hideTable() {
      this.tableShow = false;
      this.btableText = "查看列表";
    },
    pageChange: function(page) {
      this.currentPage = page;
      this.data1 = this.totalData.slice(
        (page - 1) * 5,
        page * 5 > this.totalSize ? this.totalSize : page * 5
      );
    },
    controlTable: function() {
      if (this.selectUserId === "all") {
        this.$Message.info("全部用户暂时只支持下载");
        return;
      }
      this.tableShow = !this.tableShow;
      if (this.tableShow) {
        this.btableText = "隐藏列表";
      } else {
        this.btableText = "查看列表";
      }
    },
    changeType: function(type) {
      console.log(type);
      this.type = type;

      // console.log(this.normalMarkers.length);
      // console.log(this.planMarkers.length);

      // switch (type) {
      //   case "0": //规划线路
      //     this.addPlan();
      //     this.removeNormal();
      //     break;
      //   case "1": //实际线路
      //     this.addNormal();
      //     this.removePlan();
      //     break;
      //   case "2": //全部线路
      //     this.addNormal();
      //     this.addPlan();
      //     break;
      // }
    },
    addNormal: function() {
      for (let marker of this.normalMarkers) {
        marker.addTo(this.map);
      }
      for (let line of this.normalLine) {
        line.addTo(this.map);
      }
    },
    removeNormal: function() {
      for (let marker of this.normalMarkers) {
        marker.remove();
      }
      for (let line of this.normalLine) {
        line.remove();
      }
    },
    addPlan: function() {
      for (let marker of this.planMarkers) {
        marker.addTo(this.map);
      }
      for (let line of this.planLine) {
        line.addTo(this.map);
      }
    },
    removePlan: function() {
      for (let marker of this.planMarkers) {
        marker.remove();
      }
      for (let line of this.planLine) {
        line.remove();
      }
    },
    getCustCity: async function() {
      //获取城市列表
      const params = {
        userIds: sessionStorage.getItem("userIds"),
        returnId: true
      };
      this.cityList = [];
      const res = await getData.post(api.custCity, params);

      if (res.data && res.data.status) {
        this.cityUserMap = new Map();
        for (let city in res.data.city) {
          this.cityUserMap.set(city, res.data.city[city]);
          if (this.cityList.length === 0) {
            this.cityName = city;
            this.changeCity(city);
          }
          this.cityList.push({
            value: city,
            label: city
          });
        }
      } else {
        // this.closeLoading();
        // this.$Message.info("暂无客户数据");
      }
    },
    changeCity(cityName) {
      this.userList = [];

      this.userTypeMap.set("BC", []);
      this.userTypeMap.set("ABC", []);
      this.userTypeMap.set("全部", []); //保存全部的人员

      this.checkCity = cityName;

      if (this.cityUserMap && this.cityUserMap.has(cityName)) {
        for (let user of this.cityUserMap.get(cityName)) {
          this.userTypeMap.get("全部").push({
            //全部的都保存一下
            value: user.id,
            label: user.name
          });
          if (user.srCode.startsWith("NP")) {
            this.userTypeMap.get("ABC").push({
              value: user.id,
              label: user.name
            });
          } else {
            this.userTypeMap.get("BC").push({
              value: user.id,
              label: user.name
            });
          }
        }
        this.userType = "全部";
        this.changeUserType("全部");
      }
    },
    changeUserType(userType) {
      if (userType === "全部" && this.dowloadAdata) {
        this.userList = [
          {
            label: "全部",
            value: "all"
          }
        ];
      } else {
        this.userList = [];
      }
      this.userList = this.userList.concat(this.userTypeMap.get(userType));
      if (this.userList.length !== 0) {
        this.userName = this.userList[0].value;
        this.selectUserId = this.userList[0].value;
      }
    },
    changeUser(id) {
      this.selectUserId = id;
    },
    //日期更改触发
    dateChange: async function(date) {
      if (date[0] === "") return; //清空日期
      this.startDate = date[0];
      this.endDate = date[1];
    },
    rgChange(ra) {
      if (ra === "规划线路") {
        this.checkType = 0;
        this.columns1 = this.basicInfo;
        this.totalSize = this.planListDates.length;
        this.totalData = this.planListDates;
      } else {
        this.checkType = 1;
        this.columns1 = this.basicInfo.concat(this.times);
        this.totalSize = this.normalListDates.length;
        this.totalData = this.normalListDates;
      }
      this.pageChange(1);
    },
    //添加同一天的点和线
    addPlanMarkersLine: function(obj, markerArry, lineArray, isPlan) {
      const orderIdMap = new Map();
      if (isPlan) {
        let j = 1;
        for (const orderId of obj.planedOrders) {
          orderIdMap.set(orderId, j);
          j++;
        }
      }
      let pointsBounds = []; //用来设置地图的显示范围
      for (let i = 0; i < obj.geoPoints.length; i++) {
        let getPoint = obj.geoPoints[i];
        let num = isPlan
          ? orderIdMap.get(getPoint.attrs.CustomerNumber)
          : i + 1;
        let latLngs = isPlan
          ? [getPoint.point.coordinates[1], getPoint.point.coordinates[0]]
          : [getPoint.Latitude, getPoint.Longitude];
        pointsBounds.push(latLngs);
        // let name = isPlan ? getPoint.attrs.CustomerName : getPoint.CustomerName;
        let name;
        let address;
        let srName;
        let srCode;
        let otm;
        let popu;
        if (isPlan) {
          name = getPoint.attrs.CustomerName;
          address = getPoint.attrs.CustomerAddress;
          srName = getPoint.attrs.SR;
          srCode = getPoint.attrs.SRCode;
          otm = getPoint.attrs.OTMClass;

          popu = `<div class="popup">
                      <p>${name}</p>
                      <p><span>地址：</span><span>${address}</span></p>
                      <p><span>负责人：</span><span>${srName}</span></p>
                      <p><span>SRCode：</span><span>${srCode}</span></p>
                      <p><span>OTM：</span><span>${otm}</span></p>
                    </div>`;
        } else {
          name = getPoint.CustomerName;
          address = getPoint.CustomerAddress;
          srName = getPoint.SR;
          srCode = getPoint.SalesPersonCode;
          const mstart = moment(getPoint.StartTime, "HH:mm");
          const mend = moment(getPoint.EndTime, "HH:mm");
          const time = mend.diff(mstart, "minutes", true).toFixed(2);

          popu = `<div class="popup">
                      <p>${name}</p>
                      <p><span>地址：</span><span>${address}</span></p>
                      <p><span>负责人：</span><span>${srName}</span></p>
                      <p><span>SRCode：</span><span>${srCode}</span></p>
                      <p><span>到达时间：</span><span>${
                        getPoint.StartTime
                      }</span></p>
                      <p><span>离开时间：</span><span>${
                        getPoint.EndTime
                      }</span></p>
                      <p><span>驻留时间：</span><span>${time}分</span></p>
                    </div>`;
        }
        let divHtml = `<div class='way-points' style='background-color:${
          obj.color
        }'>${num}</div>`;
        let wayDivIcon = new L.divIcon({
          html: divHtml,
          className: "leaflet-direction-icon"
        });
        markerArry.push(
          L.marker(latLngs, {
            icon: wayDivIcon
          })
            .addTo(this.map)
            .bindPopup(popu)
        );
      }
      this.map.fitBounds(pointsBounds);
      if (isPlan) {
        let polyline = L.polyline(obj.path, {
          color: obj.color
        })
          .addTo(this.map)
          .bindPopup(obj.dateId);
        lineArray.push(polyline);
      } else {
        let polyline = L.polyline(obj.path);
        let decorator = L.polylineDecorator(polyline, {
          patterns: [
            // defines a pattern of 10px-wide dashes, repeated every 20px on the line
            {
              offset: 0,
              repeat: 20,
              symbol: L.Symbol.dash({
                pixelSize: 10,
                pathOptions: { color: obj.color, weight: 3 }
              })
            }
          ]
        })
          .addTo(this.map)
          .bindPopup(obj.dateId);
        lineArray.push(decorator);
      }
    },
    getPlanDatas: async function(userId, startDate, endDate) {
      let params = {
        user_id: userId,
        startDate: startDate,
        endDate: endDate,
        dataInfo: true
      };
      const res = await getData.get(api.allDates, params);
      if (
        res.data &&
        res.data.status &&
        Object.keys(res.data.dates).length !== 0
      ) {
        const dates = res.data.dates;
        let colori = 0;
        for (let str in dates) {
          if (!dates[str].geoPoints) continue;
          let newCount = 0;
          for (let point of dates[str].geoPoints) {
            if (point.attrs.OTMClass === "P") {
              newCount += 1;
            }
          }
          this.planListDates.push({
            num: colori + 1,
            date: str,
            custCount: dates[str].geoPoints.length,
            distance: `${(dates[str].distance / 1000).toFixed(2)}km`,
            time: (dates[str].duration / 60).toFixed(2),
            // efficiency: (
            //   dates[str].duration /
            //   60 /
            //   dates[str].geoPoints.length
            // ).toFixed(2),
            oldCust: dates[str].geoPoints.length - newCount,
            newCust: newCount
          });

          this.addPlanMarkersLine(
            {
              dateId: str,
              geoPoints: dates[str].geoPoints,
              path: dates[str].path,
              color: `#${getColors[colori]}`,
              planedOrders: dates[str].planOrders
            },
            this.planMarkers,
            this.planLine,
            true
          );
          colori += 1;
        }
        this.totalSize = this.planListDates.length;
        this.rgChange("规划线路");
      }
    },
    getNormalDatas: async function(userId, startDate, endDate) {
      let params = {
        user_id: userId,
        startDate: startDate,
        endDate: endDate
      };
      const res = await getData.get(api.allNormalData, params);
      if (
        res.data &&
        res.data.status &&
        Object.keys(res.data.dates).length !== 0
      ) {
        const dates = res.data.dates;
        let colori = 0;
        for (let str in dates) {
          if (!dates[str].geoPoints) continue;
          let time = 0;
          let starTime = "";
          let endTime = "";
          if (dates[str].geoPoints.length > 0) {
            starTime = dates[str].geoPoints[0].StartTime;
            endTime =
              dates[str].geoPoints[dates[str].geoPoints.length - 1].EndTime;
            const mstart = moment(starTime, "HH:mm");
            const mend = moment(endTime, "HH:mm");
            time = mend.diff(mstart, "hours", true).toFixed(2);
          }
          this.normalListDates.push({
            num: colori + 1,
            date: str,
            custCount: dates[str].geoPoints.length,
            distance: `${(dates[str].distance / 1000).toFixed(2)}km`,
            time: time,
            // efficiency: (time / dates[str].geoPoints.length).toFixed(2),
            oldCust: dates[str].geoPoints.length,
            newCust: 0,
            startTime: starTime,
            endTime: endTime
          });

          this.addPlanMarkersLine(
            {
              dateId: str,
              geoPoints: dates[str].geoPoints,
              path: dates[str].path,
              color: `#${getColors[colori]}`,
              planedOrders: dates[str].planOrders
            },
            this.normalMarkers,
            this.normalLine,
            false
          );
          colori += 1;
        }
      }
    },
    configDowload: function() {
      //初始化是否下载全部数据
      if (sessionStorage.getItem("userId") === "admin") {
        this.dowloadAdata = true;
        this.type = "0";
        this.typeList = [
          {
            value: "0",
            label: "规划线路"
          },
          {
            value: "1",
            label: "实际线路"
          }
        ];
      } else {
        this.dowloadAdata = false;
        this.type = "2";
        this.typeList = [
          {
            value: "0",
            label: "规划线路"
          },
          {
            value: "1",
            label: "实际线路"
          },
          {
            value: "2",
            label: "全部线路"
          }
        ];
      }
    },
    downAllData: async function() {
      //数据一键导出
      if (!this.checkCity) {
        this.$Message.info("请选择城市");
        return;
      }
      if (!this.startDate) {
        this.$Message.info("请设置起始时间");
        return;
      }
      if (!this.endDate) {
        this.$Message.info("请设置结束时间");
        return;
      }
      const params = {
        city: this.checkCity, //all
        userId: this.selectUserId, //all
        startDate: this.startDate, //开始时间
        endDate: this.endDate //结束时间
      };
      const parmUrl = stringUtil.obj2url(params);
      if (this.type === "0") {
        //规划线路
        window.open(appConfig.BASE_URL + api.down_plandata + parmUrl);
      } else {
        //实际线路
        window.open(appConfig.BASE_URL + api.down_normaldata + parmUrl);
      }
    },
    downDate(date) {
      this.downMonth = date;
    },
    downNormal: async function() {
      if (!this.downMonth) {
        this.$Message.info("请选择下载月份");
        return;
      }
      const parmUrl = stringUtil.obj2url({
        month: this.downMonth
      });
      window.open(appConfig.BASE_URL + api.down_monthNormaldata + parmUrl);
    },
    downPlan: async function() {
      if (!this.downMonth) {
        this.$Message.info("请选择下载月份");
        return;
      }
      window.open(
        appConfig.BASE_URL +
          api.down_monthPlandata +
          "planInfo" +
          this.downMonth +
          ".csv"
      );
    }
  }
};
</script>
<style lang="less">
.map-control {
  width: 100%;
  height: calc(~"100% - 32px");
}
.list_control {
  position: absolute;
  padding: 8px 0;
  width: calc(~"100% - 166px");
  height: 50%;
  bottom: 8px;
  z-index: 1001;
  background-color: #fff;
  .control {
    overflow: hidden;
    margin-bottom: 8px;
  }
}
.page_control {
  margin-top: 15px;
}
#mapContainer {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Compare.vue